package com.eladfinish.bible.contest.features.share

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.platform.share.ShareCampaign
import com.eladfinish.bible.contest.platform.share.withStoreLinks
import com.eladfinish.bible.contest.shareText_txt
import com.eladfinish.bible.contest.share_app_name

class ShareAppUseCaseCommon(
    private val shareLauncher: ShareLauncher,
    private val assetReader: AssetReader,
) {
    suspend operator fun invoke() {
        val raw = assetReader.readFile(SharedRes.assets.other.shareText_txt)
        shareLauncher.shareText(
            text = raw.withStoreLinks(campaign = ShareCampaign.SHARE_APP),
            stringResource = SharedRes.strings.share_app_name,
        )
    }
}
